import { RADIO_CARD_CONST } from './RadioCard.d';
import { RadioCard } from './RadioCard.styles';
import type { RadioProps } from '../Radio';

const RadioCardBase = ({ children, ...rest }: RadioProps) => (
  <RadioCard data-testid={RADIO_CARD_CONST.TEST_ID} {...rest}>
    {children}
  </RadioCard>
);

export default RadioCardBase;
